import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export type SkillEntry = {
  name: string;
  description: string;
  dir: string;
};

export function useSkills() {
  return useQuery({
    queryKey: ['skills'],
    queryFn: async () => {
      const r = await api<{ skills: SkillEntry[] }>('/skills');
      return r.skills;
    },
    // Skills are baked into the image; don't refetch aggressively.
    staleTime: 5 * 60_000,
  });
}
